import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=081553aa&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=081553aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081553aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081553aa')) {
      api.createRecord('081553aa', component.options)
    } else {
      api.reload('081553aa', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=081553aa&scoped=true&", function () {
      api.rerender('081553aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20RYvcIVcSRAK/JS/comp/DocBox.vue"
export default component.exports